export const metaDataOptions = [
  "",
  "Customer",
  "Account",
  "SupportCase",
  "Lead",
  "Prospect",
  "Contact",
  "Order",
  "Opportunity"
].sort();